import React from "react";
import Newsdetails from "../components/News/Newsdetails";

const Newsdetail = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Newsdetails />
    </div>
  );
};

export default Newsdetail;
